import _ from "lodash";

const listColorPieChart = ["#d8d8d8", "#9fd469", "#b2d6d2", "#a6cee3", "#84a5c3"];

function shadeColor(color) {
  let R = Math.round((parseInt(color.substring(1, 3), 16) + 255) / 2);
  let G = Math.round((parseInt(color.substring(3, 5), 16) + 255) / 2);
  let B = Math.round((parseInt(color.substring(5, 7), 16) + 255) / 2);

  R = R < 255 ? R : 255;
  G = G < 255 ? G : 255;
  B = B < 255 ? B : 255;

  const RR = R.toString(16).length == 1 ? "0" + R.toString(16) : R.toString(16);
  const GG = G.toString(16).length == 1 ? "0" + G.toString(16) : G.toString(16);
  const BB = B.toString(16).length == 1 ? "0" + B.toString(16) : B.toString(16);

  return "#" + RR + GG + BB;
}

function getContrast(hexcolorOld) {
  let hexcolor = hexcolorOld;
  if (hexcolor.slice(0, 1) === "#") {
    hexcolor = hexcolor.slice(1);
  }

  if (hexcolor.length === 3) {
    hexcolor = hexcolor
      .split("")
      .map(function(hex) {
        return hex + hex;
      })
      .join("");
  }

  const r = parseInt(hexcolor.substr(0, 2), 16) * 299;
  const g = parseInt(hexcolor.substr(2, 2), 16) * 587;
  const b = parseInt(hexcolor.substr(4, 2), 16) * 114;

  const yiq = (r + g + b) / 1000;
  return yiq >= 128 ? "#000000" : "#ffffff";
}

function getAnswerValue(data) {
  let value = "";
  if (data.answer != "") {
    value = data.total;
  } else {
    value = 0;
  }
  return value;
}

function generateHorizontalBarChart(datasources = [], primaryColor = "") {
  let tmpData = [];
  let categories = [];
  let datasets = [];
  let choosenAnswers = [];

  if (!datasources || !Array.isArray(datasources) || datasources.length < 1) {
    return { categories, datasets };
  }

  for (const item of datasources) {
    for (const sd of item.surveyData) {
      const indexData = _.findIndex(tmpData, [d => d.label === sd.answer]);

      if (indexData > -1) {
        tmpData[indexData]["value"] += sd.total;
      } else {
        let color = "";
        const payload = {};

        if (item.choosenAnswer.includes(sd.answer)) {
          color = primaryColor;
          payload["label"] = (sd.answer ? sd.answer : "") + " (Me)";
        } else {
          color = shadeColor(primaryColor, 30);
          payload["label"] = sd.answer;
        }
        payload["value"] = getAnswerValue(sd);
        payload["color"] = color;

        tmpData.push(payload);
      }
    }
    choosenAnswers = item.choosenAnswer;
  }

  tmpData = tmpData.sort((a, b) => b.value - a.value);
  categories = tmpData.map(td => ({ label: td.label }));
  datasets = tmpData.map(td => ({
    value: td.value,
    color: td.color,
    tooltext: `
    <div style='font-size: 12px; font-weight: 500; padding:10px; color:${getContrast(td.color)};background-color:${td.color}; border-radius: 8px;'>
        <div>$dataValue Participants</div>
        <div>${primaryColor == td.color ? "My Response" : ""}</div>
    </div>`
  }));

  //remove 0 and null string value from label and value beacuase we don't need to show on graph
  const nonZeroValue = datasets.filter(e => e.value != 0);
  const nonNullLabel = categories.filter(e => e.label != "" && e.label != " (Me)");
  datasets = nonZeroValue;
  categories = nonNullLabel;
  return { categories, datasets, choosenAnswers };
}

function generatedPieChart(datasources = [], primaryColor = "", dataParticipantName = "") {
  const data = [];
  let choosenAnswers = [];

  if (!datasources || !Array.isArray(datasources) || datasources.length < 1) {
    return data;
  }

  for (const item of datasources) {
    let total = 0;
    for (let i = 0; i < item.surveyData.length; i++) {
      total += item.surveyData[i].total;
    }

    for (let i = 0; i < item.surveyData.length; i++) {
      const sd = item.surveyData[i];
      const indexData = _.findIndex(data, [d => d.label === sd.answer]);

      if (indexData > -1) {
        data[indexData]["value"] += sd.total;
      } else {
        let color = "";
        const payload = {};
        let percentage = 0;
        let answer = sd.answer;

        percentage = Math.round((sd.total * 100) / total);
        if (answer.indexOf(".", answer.length - 1) !== -1) {
          answer = answer.substring(0, answer.length - 1);
        }
        if (item.choosenAnswer.includes(sd.answer)) {
          color = primaryColor;
          payload["label"] = (answer || "") + ` (${dataParticipantName || "Me"})`;
        } else {
          color = listColorPieChart[i] || shadeColor(primaryColor, 30);
          payload["label"] = answer;
        }
        payload["value"] = getAnswerValue(sd);
        payload["color"] = color;
        payload["tooltext"] = `
                <div style='font-size: 12px; font-weight: 500; padding:10px; color:${getContrast(color)};background-color:${color}; border-radius: 8px;'>
                    <div>${percentage}% ${primaryColor == color ? answer : "$label"}</div>
                    <div>${primaryColor == color ? "My Response" : ""}</div>
                </div>`;

        data.push(payload);
      }
    }
    choosenAnswers = item.choosenAnswer;
  }

  for (let i = 0; i < data.length; i++) {
    const currenData = data[i];

    if (choosenAnswers.includes(currenData.label)) {
      const tmpFirstIndex = data[0];

      currenData.color = primaryColor;

      data[0] = currenData;
      data[i] = tmpFirstIndex;
      break;
    }
  }
  data.forEach(function(item, i) {
    if (item.label.includes(dataParticipantName || "Me")) {
      data.splice(i, 1);
      data.unshift(item);
    }
  });
  return { data, choosenAnswers };
}

function generateVerticalBarChartCard(datasources = [], primaryColor = "", dataParticipantName = "") {
  const tmpData = [];
  const categories = [];
  const datasets = [];
  let choosenAnswers = [];
  if (!datasources || !Array.isArray(datasources) || datasources.length < 1) {
    return { categories, datasets };
  }
  datasources.sort((a, b) => parseInt(a.milestoneName) - parseInt(b.milestoneName));
  for (const item of datasources) {
    const indexMileStone = _.findIndex(tmpData, [d => d.name === item.milestoneName]);

    if (indexMileStone < 0) {
      const payload = {};

      payload["name"] = item.milestoneName;
      payload["data"] = [];

      for (let i = 0; i < item.surveyData.length; i++) {
        const data = item.surveyData[i];
        const indexData = _.findIndex(payload["data"], [d => d.label === data.answer]);

        if (indexData > -1) {
          payload["data"][indexData]["value"] += data.total;
        } else {
          let color = "";
          const dp = {};

          if (item.choosenAnswer.includes(data.answer)) {
            color = primaryColor;
            dp["label"] = "Me";
            dp["answer"] = data.answer;
          } else {
            color = shadeColor(primaryColor, 30);
            dp["label"] = "other";
            dp["answer"] = data.answer;
          }
          dp["value"] = getAnswerValue(data);
          dp["color"] = color;

          payload["data"].push(dp);
        }
      }

      tmpData.push(payload);
    } else {
      for (let i = 0; i < item.surveyData.length; i++) {
        const data = item.surveyData[i];
        const indexData = _.filter(tmpData[indexMileStone]["data"], [d => d.label === data.answer]);

        if (indexData > -1) {
          tmpData[indexMileStone]["data"][indexData].value += data.total;
        } else {
          let color = "";
          const dp = {};

          if (item.choosenAnswer.includes(data.answer)) {
            color = primaryColor;
            dp["label"] = "Me";
            dp["answer"] = data.answer;
          } else {
            color = shadeColor(primaryColor, 30);
            dp["label"] = "other";
            dp["answer"] = data.answer;
          }
          dp["value"] = getAnswerValue(data);
          dp["color"] = color;

          tmpData[indexMileStone]["data"].push(dp);
        }
      }
    }
    choosenAnswers = item.choosenAnswer;
  }

  const tmpDatasets = [];

  for (let i = 0; i < tmpData.length; i++) {
    const data = tmpData[i];
    let otherValue = 0;

    let otherData = [];
    let meValue = 0;

    let meData = [];
    let otherCount = 0;

    categories.push({ label: data.name });

    data.data.map(dd => {
      if (dd.label == "Me") {
        if (dd.value > 1) {
          const ansVal = parseInt(dd.answer) * (parseInt(dd.value) - 1);
          otherValue = otherValue + ansVal;
          otherCount = otherCount + (parseInt(dd.value) - 1);
        }
        meValue = dd.answer;
      } else {
        const ansVal = parseInt(dd.answer) * parseInt(dd.value);
        otherValue = otherValue + ansVal;
        otherCount = otherCount + dd.value;
      }
    });

    meData = {
      color: primaryColor,
      label: dataParticipantName || "Me",
      value: parseInt(meValue)
    };
    tmpDatasets.push(meData);

    otherData = {
      color: shadeColor(primaryColor, 30),
      label: "Others",
      value: otherValue / otherCount
    };
    tmpDatasets.push(otherData);
  }

  tmpDatasets.map(td => {
    const indexDataset = datasets.findIndex(d => d.seriesname === td.label);
    if (td.value != 0) {
      if (indexDataset > -1) {
        datasets[indexDataset]["data"].push({
          value: td.value,
          color: td.color,
          tooltext: `
                <div style='font-size: 12px; font-weight: 500; padding:10px; color:${getContrast(td.color)};background-color:${td.color}; border-radius: 8px;'>
                    <div>$dataValue FVC</div>
                    <div>${primaryColor == td.color ? "My Response" : "Others"}</div>
                </div>`
        });
      } else {
        const p = {
          seriesname: td.label,
          color: td.color,
          data: [
            {
              value: td.value,
              color: td.color,
              tooltext: `
                <div style='font-size: 12px; font-weight: 500; padding:10px; color:${getContrast(td.color)};background-color:${td.color}; border-radius: 8px;'>
                    <div>$dataValue FVC</div>
                    <div>${primaryColor == td.color ? "My Response" : "Others"}</div>
                </div>`
            }
          ]
        };
        datasets.push(p);
      }
    }
  });

  return { categories, datasets, choosenAnswers };
}

function generateWordCloud(datasources = [], primaryColor = "") {
  const words = [];
  const colors = [];
  let choosenAnswers = [];

  if (!datasources || !Array.isArray(datasources) || datasources.length < 1) {
    return { words, colors, choosenAnswers };
  }

  for (const item of datasources) {
    choosenAnswers = item.choosenAnswer;
    for (const sd of item.surveyData) {
      const indexWords = _.findIndex(words, [d => d[0] === sd.answer]);

      if (indexWords > -1) {
        words[indexWords][1] += sd.total;
      } else {
        let color = "";
        let p = [];

        if (item.choosenAnswer.includes(sd.answer)) {
          if (sd.answer != "") {
            color = primaryColor;
            p = [sd.answer, sd.total, color];
          }
        } else {
          if (sd.answer != "") {
            color = shadeColor(primaryColor, 30);
            p = [sd.answer, sd.total, color];
          }
        }

        words.push(p);
        colors.push(color);
      }
    }
  }

  return { words, colors, choosenAnswers };
}

function generateLineChartCard(datasources = [], primaryColor = "", dataParticipantName = "") {
  const tmpData = [];
  const categories = [];
  const datasets = [];
  let choosenAnswers = [];

  if (!datasources || !Array.isArray(datasources) || datasources.length < 1) {
    return { categories, datasets };
  }

  for (const item of datasources) {
    const indexMileStone = _.findIndex(tmpData, [d => d.name === item.milestoneName]);

    if (indexMileStone < 0) {
      const payload = {};

      payload["name"] = item.milestoneName;
      payload["data"] = [];

      for (let i = 0; i < item.surveyData.length; i++) {
        const data = item.surveyData[i];
        const indexData = _.findIndex(payload["data"], [d => d.label === data.answer]);

        if (indexData > -1) {
          payload["data"][indexData]["value"] += data.total;
        } else {
          let color = "";
          const dp = {};

          if (item.choosenAnswer.includes(data.answer)) {
            color = primaryColor;
            dp["label"] = (data.answer ? data.answer : "") + ` (${dataParticipantName || "Me"})`;
          } else {
            color = shadeColor(primaryColor, 30);
            dp["label"] = data.answer;
          }
          dp["value"] = getAnswerValue(data);
          dp["color"] = color;

          payload["data"].push(dp);
        }
      }

      tmpData.push(payload);
    } else {
      for (let i = 0; i < item.surveyData.length; i++) {
        const data = item.surveyData[i];
        const indexData = _.filter(tmpData[indexMileStone]["data"], [d => d.label === data.answer]);

        if (indexData > -1) {
          tmpData[indexMileStone]["data"][indexData].value += data.total;
        } else {
          let color = "";
          const dp = {};

          if (item.choosenAnswer.includes(data.answer)) {
            color = primaryColor;
            dp["label"] = (data.answer ? data.answer : "") + ` (${dataParticipantName || "Me"})`;
          } else {
            color = shadeColor(primaryColor, 30);
            dp["label"] = data.answer;
          }
          dp["value"] = getAnswerValue(data);
          dp["color"] = color;

          tmpData[indexMileStone]["data"].push(dp);
        }
      }
    }
    choosenAnswers = item.choosenAnswer;
  }

  const tmpDatasets = [];

  for (let i = 0; i < tmpData.length; i++) {
    const data = tmpData[i];
    categories.push({ label: data.name });

    data.data.map(dd => tmpDatasets.push(dd));
  }

  tmpDatasets.map(td => {
    const indexDataset = datasets.findIndex(d => d.seriesname === td.label);
    if (td.value != 0) {
      if (indexDataset > -1) {
        datasets[indexDataset]["data"].push({
          value: td.value,
          tooltext: `
                <div style='font-size: 12px; font-weight: 500; margin-bottom:10px; padding:10px; color:${getContrast(td.color)};background-color:${td.color}; border-radius: 8px;'>
                    <div>$dataValue $label, $seriesName</div>
                    <div>${primaryColor == td.color ? "My Response" : ""}</div>
                </div>`
        });
      } else {
        const p = {
          seriesname: td.label,
          anchorBgColor: td.color,
          color: td.color,
          data: [
            {
              value: td.value,
              tooltext: `
                <div style='font-size: 12px; font-weight: 500; margin-bottom:10px; padding:10px; color:${getContrast(td.color)};background-color:${td.color}; border-radius: 8px;'>
                    <div>$dataValue $label, $seriesName</div>
                    <div>${primaryColor == td.color ? "My Response" : ""}</div>
                </div>`
            }
          ]
        };
        datasets.push(p);
      }
    }
  });

  return { categories, datasets, choosenAnswers };
}
function WordCloud(datasources = [], primaryColor = []) {
  const words = [];
  let jsa = 0;
  for (const item of datasources) {
    for (const sd of item.surveyData) {
      let p = [];
      p = [sd.answer, sd.total, primaryColor[jsa]];
      jsa += 1;
      words.push(p);
    }
  }
  return { words };
}

function generateScatterChartCard(datasources = [], primaryColor = "", dataParticipantName = "") {
  const tmpData = [];
  const categories = [];
  const datasets = [];
  let x = 10;
  let choosenAnswers = [];

  if (!datasources || !Array.isArray(datasources) || datasources.length < 1) {
    return { categories, datasets };
  }

  for (const item of datasources) {
    const indexMileStone = _.findIndex(tmpData, [d => d.name === item.milestoneName]);

    if (indexMileStone < 0) {
      const payload = {};

      payload["name"] = item.milestoneName;
      payload["x"] = x;
      payload["data"] = [];

      for (let i = 0; i < item.surveyData.length; i++) {
        const data = item.surveyData[i];
        const indexData = _.findIndex(payload["data"], [d => d.label === data.answer]);

        if (indexData > -1) {
          payload["data"][indexData]["value"] += data.total;
        } else {
          let color = "";
          const dp = {};

          if (item.choosenAnswer.includes(data.answer)) {
            color = primaryColor;
            dp["label"] = (data.answer ? data.answer : "") + ` (${dataParticipantName || "Me"})`;
          } else {
            color = shadeColor(primaryColor, 30);
            dp["label"] = data.answer;
          }
          dp["value"] = getAnswerValue(data);
          dp["color"] = color;
          dp["category"] = item.milestoneName;

          payload["data"].push(dp);
        }
      }

      x += 10;
      tmpData.push(payload);
    } else {
      for (let i = 0; i < item.surveyData.length; i++) {
        const data = item.surveyData[i];
        const indexData = _.filter(tmpData[indexMileStone]["data"], [d => d.label === data.answer]);

        if (indexData > -1) {
          tmpData[indexMileStone]["data"][indexData].value += data.total;
        } else {
          let color = "";
          const dp = {};

          if (item.choosenAnswer.includes(data.answer)) {
            color = primaryColor;
            dp["label"] = (data.answer ? data.answer : "") + ` (${dataParticipantName || "Me"})`;
          } else {
            color = shadeColor(primaryColor, 30);
            dp["label"] = data.answer;
          }

          dp["value"] = getAnswerValue(data);
          dp["color"] = color;
          dp["category"] = item.milestoneName;

          tmpData[indexMileStone]["data"].push(dp);
        }
      }
    }
    choosenAnswers = item.choosenAnswer;
  }

  const tmpDatasets = [];

  for (let i = 0; i < tmpData.length; i++) {
    const data = tmpData[i];
    categories.push({ label: data.name, x: data.x });

    data.data.map(dd => tmpDatasets.push(dd));
  }
  tmpDatasets.map(td => {
    const indexDataset = datasets.findIndex(d => d.seriesname === td.label);
    if (td.value != 0) {
      if (indexDataset > -1) {
        datasets[indexDataset]["data"].push({
          y: td.value,
          x: 10,
          tooltext: `
                <div style='font-size: 12px; font-weight: 500; padding:10px; color:${getContrast(td.color)};background-color:${td.color}; border-radius: 8px;'>
                    <div>$yvalue ${td.category}, $seriesName</div>
                    <div>${primaryColor == td.color ? "My Response" : ""}</div>
                </div>`
        });
      } else {
        const p = {
          seriesname: td.label,
          anchorBgColor: td.color,
          anchorBordercolor: td.color,
          anchorBorderThickness: "1",
          anchorsides: "0",
          anchorradius: "4",
          data: [
            {
              y: td.value,
              x: 20,
              tooltext: `
                    <div style='font-size: 12px; font-weight: 500; padding:10px; color:${getContrast(td.color)};background-color:${td.color}; border-radius: 8px;'>
                        <div>$yvalue ${td.category}, $seriesName</div>
                        <div>${primaryColor == td.color ? "My Response" : ""}</div>
                    </div>`
            }
          ]
        };
        datasets.push(p);
      }
    }
  });

  return { categories, datasets, choosenAnswers };
}

export { generateHorizontalBarChart, generatedPieChart, generateVerticalBarChartCard, generateWordCloud, shadeColor, generateLineChartCard, generateScatterChartCard, getContrast, WordCloud };
